export default function maskedCurrencyToNumber(masked: string) {
  if (!masked) return NaN;

  const normalized = masked
    .replace(/\u00A0/g, ' ')
    .replace('R$', '')
    .trim();

  if (!normalized) return NaN;

  return Number(normalized.replaceAll('.', '').replace(',', '.'));
}
